'use strict';

export default class PhysicianController {
  /*@ngInject*/
  constructor(Auth, Physician, $scope, $filter) {
    this.Auth = Auth;
    this.Physician = Physician;
    this.$scope = $scope;
    this.$filter = $filter;

    this.currentPage = 1;
    this.itemsPerPage = 5;
  }
  $onInit = () => {
    this.Physician.getTimeoutData()
      .then((response) => {
        this.timeoutData = response;
      })
  }
}



// WEBPACK FOOTER //
// ./client/app/physician/physician.controller.js